export const ENQUEUE_PUBLISH_JOB = 'ENQUEUE_PUBLISH_JOB';
export const UPDATE_PUBLISH_JOB_PROGRESS = 'UPDATE_PUBLISH_JOB_PROGRESS';
export const REMOVE_PUBLISH_JOB = 'REMOVE_PUBLISH_JOB';

export const MARK_BANNER_LIST_STALE = 'MARK_BANNER_LIST_STALE';
export const CLEAR_BANNER_LIST_STALE = 'CLEAR_BANNER_LIST_STALE';
export const MARK_TEMPLATE_LIST_STALE = 'MARK_TEMPLATE_LIST_STALE';
export const CLEAR_TEMPLATE_LIST_STALE = 'CLEAR_TEMPLATE_LIST_STALE';
export const MARK_PAGES_LIST_STALE = 'MARK_PAGES_LIST_STALE';
export const CLEAR_PAGES_LIST_STALE = 'CLEAR_PAGES_LIST_STALE';
export const MARK_CATEGORIES_LIST_STALE = 'MARK_CATEGORIES_LIST_STALE';
export const CLEAR_CATEGORIES_LIST_STALE = 'CLEAR_CATEGORIES_LIST_STALE';
export const MARK_WIDGETS_LIST_STALE = 'MARK_WIDGETS_LIST_STALE';
export const CLEAR_WIDGETS_LIST_STALE = 'CLEAR_WIDGETS_LIST_STALE';
export const MARK_SEO_LIST_STALE = 'MARK_SEO_LIST_STALE';
export const CLEAR_SEO_LIST_STALE = 'CLEAR_SEO_LIST_STALE';
export const MARK_INFORMATION_POLICY_LIST_STALE = 'MARK_INFORMATION_POLICY_LIST_STALE';
export const CLEAR_INFORMATION_POLICY_LIST_STALE = 'CLEAR_INFORMATION_POLICY_LIST_STALE';
export const MARK_ADMIN_SETTINGS_STALE = 'MARK_ADMIN_SETTINGS_STALE';
export const CLEAR_ADMIN_SETTINGS_STALE = 'CLEAR_ADMIN_SETTINGS_STALE';
export const MARK_CONFIG_SETTINGS_STALE = 'MARK_CONFIG_SETTINGS_STALE';
export const CLEAR_CONFIG_SETTINGS_STALE = 'CLEAR_CONFIG_SETTINGS_STALE';
export const MARK_SHIFT_LIST_STALE = 'MARK_SHIFT_LIST_STALE';
export const CLEAR_SHIFT_LIST_STALE = 'CLEAR_SHIFT_LIST_STALE';
export const MARK_TRANSACTION_LIST_STALE = 'MARK_TRANSACTION_LIST_STALE';
export const CLEAR_TRANSACTION_LIST_STALE = 'CLEAR_TRANSACTION_LIST_STALE';
export const MARK_SHIFT_APPLICATION_LIST_STALE = 'MARK_SHIFT_APPLICATION_LIST_STALE';
export const CLEAR_SHIFT_APPLICATION_LIST_STALE = 'CLEAR_SHIFT_APPLICATION_LIST_STALE';
export const MARK_TIMESHEET_LIST_STALE = 'MARK_TIMESHEET_LIST_STALE';
export const CLEAR_TIMESHEET_LIST_STALE = 'CLEAR_TIMESHEET_LIST_STALE';
export const MARK_STAFF_DOCUMENTS_LIST_STALE = 'MARK_STAFF_DOCUMENTS_LIST_STALE';
export const CLEAR_STAFF_DOCUMENTS_LIST_STALE = 'CLEAR_STAFF_DOCUMENTS_LIST_STALE';
